import { render, staticRenderFns } from "./tag-dialog.component.vue?vue&type=template&id=9ea5c964&scoped=true"
import script from "./tag-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./tag-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./tag-dialog.component.vue?vue&type=style&index=0&id=9ea5c964&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea5c964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ea5c964')) {
      api.createRecord('9ea5c964', component.options)
    } else {
      api.reload('9ea5c964', component.options)
    }
    module.hot.accept("./tag-dialog.component.vue?vue&type=template&id=9ea5c964&scoped=true", function () {
      api.rerender('9ea5c964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/tag-dialog/tag-dialog.component.vue"
export default component.exports